export function sanitizeDecimal(value, maxDecimals = 1) {
    let sanitized = value.replace(/[^0-9.]/g, '');

    const firstDotIndex = sanitized.indexOf('.');
    if (firstDotIndex !== -1) {
    sanitized =
        sanitized.slice(0, firstDotIndex + 1) +
        sanitized.slice(firstDotIndex + 1).replace(/\./g, '');
    }

    const parts = sanitized.split('.');
    if (parts.length === 2) {
    parts[1] = parts[1].slice(0, maxDecimals);
    sanitized = parts.join('.');
    }

    return sanitized;
}